<template>
  <v-ons-navigator swipeable :page-stack="page_stack" @push-page="page_stack.push($event)"></v-ons-navigator>
</template>

<script>
  import MusicListPage from './MusicListPage'

  export default {
    name: 'music-list-tab',
    data () {
      return {
        page_stack: [MusicListPage],
        name: 'music-list-tab'
      }
    },
    mounted: function () {
      let thisComponent = this
      document.addEventListener('clearPageStack', e => {
        if (e.detail === thisComponent.name) {
          for (let i = thisComponent.page_stack.length; i > 1; --i) {
            thisComponent.page_stack.pop()
          }
        }
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MusicListTab.vue